const stopDisabledLinksFiring = () => {
    const links = document.querySelectorAll('a[class*="-disabled"]');

    Array.prototype.forEach.call(links, link => {
        link.addEventListener('click', event => {
            event.preventDefault();
        }, false);
    });
};

stopDisabledLinksFiring();
